export const ACTIVE_PAGE = 'ACTIVE_PAGE';
export const EXAMPLE_FORM = 'EXAMPLE_FORM';

export const CZ_COUNTRY_CODE = 1;

export const FIND_OFFICIALS = 'FIND_OFFICIALS';

export const INITIATIVE = 'INITIATIVE';
export const OFFICIAL = 'OFFICIAL';
export const STATEMENT = 'STATEMENT';
export const OVM = 'OVM';
export const LEGITIMATE = 'LEGITIMATE';
export const REQUEST = 'REQUEST';
export const DICTIONARY_ITEM = 'DICTIONARY_ITEM';
export const EMAIL_TEMPLATE = 'EMAIL_TEMPLATE';

export const CZECH_REPUBLIC_ID = '401dbb93-bc84-458a-9065-df4e6baf3825';
